/* eslint-disable prettier/prettier */
export const toTitleCase = (string: string) => {
  return string?.length > 0
    ? string?.replace(
      /\w\S*/g,
      (txt) => txt?.charAt(0).toUpperCase() + txt?.substr(1).toLowerCase()
    )
    : string;
};
